import { NavLink as RouterLink, useLocation, useMatches } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { Box, Breadcrumbs, Container, Link, Typography } from '@mui/material';

// ==============================|| PAGE BREADCRUMBS ||============================== //

function PageLauanBreadcrumbs({ list = [] }) {
  const matches = useMatches();
  
  const crumbs = matches
    // first get rid of any matches that don't have handle and crumb
    .filter((match) => Boolean(match.handle?.crumb))
    // now map them into an array of elements, passing the loader
    // data to each one Boolean(match.params?.category)
    .map((match) => {
      return match.handle?.crumb(match.data, match.params)
    });
    
    
  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      separator={
        <Box
          width={2}
          height={2}
          sx={{ backgroundColor: theme => theme.palette.secondary.main }}
        />
      }
      sx={{ mb: 2.5 }}
    >
      <Link component={RouterLink} fontSize={16} color="common.white" to="/honhai/lauan/app" sx={{ textDecoration: 'auto' }}>
        首頁
      </Link>
      {
        _.map(list, (item, index) => {
          const { label, props } = item || {};
          return (
            <Typography
              key={index}
              component={RouterLink}
              underline="hover"
              color="common.white"
              fontWeight={list?.length === (index + 1) ? 700 : 400}
              fontSize={16}
              to={props?.path}
              // onClick={item?.click ? item?.click : null}
              sx={{ cursor: 'pointer', textDecoration: 'none' }}
            >
              { label }
            </Typography>
          )
        })
      }
    </Breadcrumbs>
  );
};

export default PageLauanBreadcrumbs;